var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 col-md-8 offset-md-2 col-lg-6 offset-lg-4 col-xl-8 offset-xl-2",domProps:{"innerHTML":_vm._s(_vm.value.code)}})])}
var staticRenderFns = []

export { render, staticRenderFns }